// https://www.devmedia.com.br/validar-cpf-com-javascript/23916
export function validarCpf(cpf) {
  const sanitizedCpf = cpf.replace(/[^\d]+/g, '')

  if (sanitizedCpf.length !== 11 || /^(\d)\1{10}$/.test(sanitizedCpf)) {
    return false
  }

  let soma = 0
  let resto

  for (let i = 1; i <= 9; i++) {
    soma += parseInt(sanitizedCpf.substring(i - 1, i), 10) * (11 - i)
  }
  resto = (soma * 10) % 11

  if (resto === 10 || resto === 11) {
    resto = 0
  }

  if (resto !== parseInt(sanitizedCpf.substring(9, 10), 10)) {
    return false
  }

  soma = 0
  for (let i = 1; i <= 10; i++) {
    soma += parseInt(sanitizedCpf.substring(i - 1, i), 10) * (12 - i)
  }
  resto = (soma * 10) % 11

  if (resto === 10 || resto === 11) {
    resto = 0
  }

  if (resto !== parseInt(sanitizedCpf.substring(10, 11), 10)) {
    return false
  }

  return true
}
